import React from "react";

export default function ContactItem({ icon, contactName, contactValue }) {
  return (
    <div className="contactItem">
      <div className="contactItemKey">
        <img src={icon} />
        <div>{contactName}</div>
      </div>
      <div className="contactItemValue">{contactValue}</div>
    </div>
  );
}
